import { Modal } from 'antd'

const CHUNK_ERROR_PATTERNS = [
  /loading chunk [\d]+ failed/i,
  /loading css chunk [\d]+ failed/i,
  /chunkloaderror/i,
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /error loading dynamically imported module/i,
  /\.chunk\.js/i,
]

let chunkErrorPromptOpen = false

const getErrorText = (error: unknown): string => {
  if (typeof error === 'string') {
    return error
  }

  if (error instanceof Error) {
    return `${error.name} ${error.message}`
  }

  if (error && typeof error === 'object') {
    const maybeError = error as { name?: unknown; message?: unknown }
    const name = maybeError.name != null ? String(maybeError.name) : ''
    const message = maybeError.message != null ? String(maybeError.message) : ''
    const combined = `${name} ${message}`.trim()
    if (combined) {
      return combined
    }
  }

  return String(error)
}

export const isChunkLoadError = (error: unknown): boolean => {
  if (!error) {
    return false
  }

  return CHUNK_ERROR_PATTERNS.some(pattern => pattern.test(getErrorText(error)))
}

export const confirmChunkReload = (): Promise<boolean> =>
  new Promise(resolve => {
    Modal.confirm({
      title: 'Доступна новая версия приложения',
      content:
        'Часть интерфейса не загрузилась из‑за обновления ERP. Перезагрузите страницу после сохранения данных. Несохранённые изменения будут потеряны.',
      okText: 'Перезагрузить',
      cancelText: 'Позже',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    })
  })

export const promptChunkReload = (): void => {
  if (chunkErrorPromptOpen) {
    return
  }

  chunkErrorPromptOpen = true
  void confirmChunkReload().then(confirmed => {
    chunkErrorPromptOpen = false
    if (confirmed) {
      window.location.reload()
    }
  })
}

export const setupChunkLoadRecovery = (): void => {
  if (typeof window === 'undefined') {
    return
  }

  window.addEventListener('unhandledrejection', event => {
    if (!isChunkLoadError(event.reason)) {
      return
    }

    event.preventDefault()
    promptChunkReload()
  })
}
